"use strict";

exports.__esModule = true;
exports.AddPartCountActionElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _AddPartCountDialog = require("./AddPartCountDialog");
var _Notifications = require("../../Notifications");
var _ManualEventsContext = require("../../Operator/ManualEventsContext");
var _Translator = require("../../Core/Translator");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 * Provides a button to be rendered on a configurable view
 */
var AddPartCountActionElement = exports.AddPartCountActionElement = function AddPartCountActionElement(props) {
  // state
  var _useState = (0, _react.useState)(false),
    isDialogOpen = _useState[0],
    setIsDialogOpen = _useState[1];
  // context
  var _React$useContext = _react["default"].useContext(_Notifications.NotificationContext),
    showNotification = _React$useContext.showNotification;
  var _React$useContext2 = _react["default"].useContext(_ManualEventsContext.ManualEventsContext),
    addPartCount = _React$useContext2.addPartCount,
    undoAddPartCount = _React$useContext2.undoAddPartCount;
  var _React$useContext3 = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext3.translate;
  var toggleDialog = function toggleDialog() {
    setIsDialogOpen(!isDialogOpen);
  };
  var invoke = function invoke() {
    setIsDialogOpen(true);
  };
  var handleSubmit = function handleSubmit(partKindQuery) {
    addPartCount(partKindQuery);
    toggleDialog();
    setTimeout(function () {
      showNotification(_Notifications.NOTIFICATION_UNDO_PART_KIND, {
        onClick: function onClick() {
          return undoAddPartCount(partKindQuery);
        }
      });
    }, 200);
  };
  var childProps = {
    invoke: invoke
  };
  if (!isDialogOpen) {
    return props.children(childProps);
  }
  var label = props.label || translate("UserAction.AddPartCount.label", "Add Part Count");
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.children(childProps), /*#__PURE__*/_react["default"].createElement(_AddPartCountDialog.AddPartCountDialog, {
    label: label,
    onSubmit: handleSubmit,
    isOpen: isDialogOpen,
    toggleDialog: toggleDialog
  }));
};